var confirmTriggers = [];
export var registerConfirmTrigger = function (trigger) {
    confirmTriggers.push(trigger);
};
export var confirm = function (confirm) {
    confirmTriggers.forEach(function (confirmTrigger) {
        confirmTrigger(confirm);
    });
};
